import React from 'react';

import CompareLandingHelmet from 'common/helmets/CompareLandingHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import AhaIcon from 'img/landing/aha-icon.webp';
import ProductboardIcon from 'img/landing/pb-icon.webp';
import PendoIcon from 'img/landing/pendo-icon.webp';
import TrelloIcon from 'img/landing/trello-icon.webp';
import UserVoiceIcon from 'img/landing/uservoice-icon.webp';

import 'css/components/www/_LandingDirectory.scss';

const CompareLanding = () => {
  return (
    <div className="landingDirectory">
      <CompareLandingHelmet />
      <div className="landingDirectoryContainer">
        <div className="header">
          <div className="left">
            <div className="text">
              <h1 className="title">A look at the top Canny&nbsp;alternatives</h1>
              <div className="subtitle">See why other teams choose&nbsp;Canny</div>
            </div>
          </div>
        </div>
        <div className="directoryGrid">
          <Link className="directoryItem" to="/compare/uservoice">
            <div className="directoryItemContents">
              <LazyLoadedImage
                alt="UserVoice logo"
                loading="eager"
                className="productIcon"
                src={UserVoiceIcon}
              />
              <div className="text">
                <div className="productName">UserVoice</div>
                <div className="description">
                  Canny is a modern tool with just the features you need. UserVoice is stuck in
                  the&nbsp;past.
                </div>
              </div>
            </div>
          </Link>
          <Link className="directoryItem" to="/compare/aha">
            <div className="directoryItemContents">
              <LazyLoadedImage
                alt="Aha logo"
                loading="eager"
                className="productIcon"
                src={AhaIcon}
              />
              <div className="text">
                <div className="productName">Aha</div>
                <div className="description">
                  You're making customer feedback a prioritiy, the tool you choose should&nbsp;too.
                </div>
              </div>
            </div>
          </Link>
          <Link className="directoryItem" to="/compare/trello">
            <div className="directoryItemContents">
              <LazyLoadedImage
                alt="Trello logo"
                loading="eager"
                className="productIcon"
                src={TrelloIcon}
              />
              <div className="text">
                <div className="productName">Trello</div>
                <div className="description">
                  Canny is a dedicated tool for customer feedback. Trello wasn't built
                  for&nbsp;this.
                </div>
              </div>
            </div>
          </Link>
          <Link className="directoryItem" to="/compare/productboard">
            <div className="directoryItemContents">
              <LazyLoadedImage
                alt="ProductBoard logo"
                loading="eager"
                className="productIcon"
                src={ProductboardIcon}
              />
              <div className="text">
                <div className="productName">Productboard</div>
                <div className="description">
                  Productboard is an overly-complicated product management tool where user feedback
                  is an&nbsp;afterthought.
                </div>
              </div>
            </div>
          </Link>
          <Link className="directoryItem" to="/compare/pendo">
            <div className="directoryItemContents">
              <LazyLoadedImage
                alt="Pendo logo"
                loading="eager"
                className="productIcon"
                src={PendoIcon}
              />
              <div className="text">
                <div className="productName">Pendo</div>
                <div className="description">
                  Pendo is a pricey product analytics tool. Product feedback isn’t their focus and
                  it&nbsp;shows.
                </div>
              </div>
            </div>
          </Link>
        </div>
        <h2 className="heading">Why customers love Canny</h2>
        <div className="reasons">
          <div className="reason">
            <h3 className="reasonHeader">Feedback first</h3>
            <p className="reasonText">
              We created Canny to help SaaS companies build better products with user feedback. It's
              our foundation. All our tools are intertwined with feedback. Most Canny alternatives
              treat feedback like an&nbsp;afterthought.
            </p>
          </div>
          <div className="reason">
            <h3 className="reasonHeader">Stellar design and user experience</h3>
            <p className="reasonText">
              Canny is straightforward and intuitive to use. It's easy to set up, customize, and not
              unnecessarily&nbsp;complicated.
            </p>
          </div>
          <div className="reason">
            <h3 className="reasonHeader">Excellent customer experience</h3>
            <p className="reasonText">
              We're committed to solving customer needs and delivering great support. Small
              businesses and product teams at enterprise companies — everyone matters to&nbsp;us.
            </p>
          </div>
          <div className="reason">
            <h3 className="reasonHeader">Flexible pricing plans</h3>
            <p className="reasonText">
              We have a pricing plan for every stage of your company's feedback journey. Just
              getting started? Try our Free plan for as long as you need. Ready for more power? Give
              our Growth and Business plans a try. All plans include unlimited tracked users,
              contributors, and affordable admin seats. No surprises&nbsp;here.
            </p>
          </div>
          <div className="reason">
            <h3 className="reasonHeader">Everything you need to close the feedback loop</h3>
            <p className="reasonText">
              Canny has powerful tools for every stage of the feedback loop. Build your own feedback
              board to collect, manage, and analyze all your feedback. Prioritize feature requests
              and maintain your public roadmap. Then, announce your new features with our
              changelog&nbsp;tool.
            </p>
          </div>
          <div className="reason">
            <h3 className="reasonHeader">Powerful integrations</h3>
            <p className="reasonText">
              Integrate your customer support, project management, and team collaboration tools with
              Canny. Canny supports your team's&nbsp;workflow.
            </p>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};
export default CompareLanding;
